module.exports = __webpack_public_path__ + "img/dd.f0f5bf9a.png";